import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=a3d8b1ac&"
import script from "./SectionList.vue?vue&type=script&lang=js&"
export * from "./SectionList.vue?vue&type=script&lang=js&"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=a3d8b1ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports